import type { UserData } from '../types'

const USER_STORAGE_KEY = 'userData'
const AUTH_FLAG_KEY = 'isAuthenticated'

/**
 * Проверить, был ли пользователь авторизован
 */
export const wasUserAuthenticated = (): boolean => {
  return localStorage.getItem(AUTH_FLAG_KEY) === 'true'
}

/**
 * Загрузить данные пользователя из localStorage
 * Возвращает null если кеш пуст или невалиден
 */
export const loadUserFromCache = (): UserData | null => {
  const cachedData = localStorage.getItem(USER_STORAGE_KEY)
  if (!cachedData) return null

  try {
    return JSON.parse(cachedData) as UserData
  } catch (error) {
    console.warn('[UserCache] Failed to parse cache. Clearing.', error)
    clearUserCache()
    return null
  }
}

/**
 * Сохранить данные пользователя в localStorage
 */
export const saveUserToCache = (userData: UserData): void => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userData))
  localStorage.setItem(AUTH_FLAG_KEY, 'true')
}

/**
 * Очистить данные пользователя из localStorage
 */
export const clearUserCache = (): void => {
  localStorage.removeItem(USER_STORAGE_KEY)
  localStorage.removeItem(AUTH_FLAG_KEY)
}
